/**
 * src/assets/i18n/{}.json의 Code를 한번 매핑한다.
 */
export const LangConstants = {
  lang: 'lang_code'
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/src/lang.constants.ts